import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";

const LAST_UPDATED = "10 July 2026";

const TermsAndConditionsPage = () => (
  <LegalDocumentPage
    eyebrow="Legal"
    title="Terms & Conditions"
    summary="These terms govern your use of InfoBoxx — Ghana’s category-based platform for trusted guidance and qualified connections with verified service providers. By accessing InfoBoxx, you agree to these terms."
    lastUpdated={LAST_UPDATED}
    relatedLinks={[
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/cookies", label: "Cookie Policy" },
    ]}
    sections={[
      {
        heading: "1. About InfoBoxx",
        paragraphs: [
          "InfoBoxx provides educational content, topic hubs, articles, media, and tools across categories such as Legal, Real Estate & Mortgages, Health, Careers, Nutrition & Meal Plans, and Betting & Gaming. Our goal is to help you understand a decision before you speak to a provider.",
          "InfoBoxx is a technology and content platform. Unless we expressly say otherwise, we are not your lawyer, doctor, lender, employer, nutritionist, or betting operator. Partner providers remain responsible for the professional services they deliver.",
        ],
      },
      {
        heading: "2. Eligibility and accounts",
        paragraphs: [
          "You must provide accurate registration details and keep them up to date. Account access may use one-time passwords (OTP) or similar verification. You are responsible for activity under your account and for keeping verification codes private.",
          "Some topic libraries (articles and media) may require registration and an interest in that category or subcategory. Adding interests helps us show relevant content and route requests fairly.",
        ],
      },
      {
        heading: "3. Acceptable use",
        paragraphs: [
          "You agree to use InfoBoxx lawfully and respectfully. You must not:",
        ],
        bullets: [
          "Misrepresent your identity or submit false enquiries to partners.",
          "Scrape, copy, or republish InfoBoxx content at scale without permission.",
          "Attempt to disrupt the platform, bypass access controls, or misuse partner contact channels.",
          "Use Betting & Gaming content in ways that promote illegal or harmful gambling behaviour.",
          "Upload unlawful, abusive, or infringing material where user submissions are allowed.",
        ],
      },
      {
        heading: "4. Content and guidance",
        paragraphs: [
          "Guides, checklists, FAQs, articles, and media are for general information. They are not a substitute for professional advice tailored to your situation. Always confirm critical steps — especially land transactions, legal filings, medical decisions, financial commitments, and regulated gaming — with a qualified professional.",
          "Content may be updated, sponsored, or contributed by verified partners. Sponsorship does not remove our expectation that information remains useful and clear for consumers.",
        ],
      },
      {
        heading: "5. Partners, leads, and bookings",
        paragraphs: [
          "When you choose actions such as “Talk to an expert,” WhatsApp contact, or booking an appointment, you authorise InfoBoxx to share relevant details with the selected or assigned partner so they can respond.",
          "Partners set their own fees, availability, and service terms. InfoBoxx does not guarantee that a partner will accept every request, or any particular outcome of advice or services they provide. Disputes about a partner’s service should be raised with that partner in the first instance.",
        ],
      },
      {
        heading: "6. Intellectual property",
        paragraphs: [
          "The InfoBoxx name, logo, design system, and platform software are owned by InfoBoxx or its licensors. Category content may include partner materials used under licence. You may use the site for personal, non-commercial learning. Any other use requires prior written consent.",
        ],
      },
      {
        heading: "7. Availability and changes",
        paragraphs: [
          "We aim for reliable access but do not guarantee uninterrupted service. Features, categories, and partner coverage may change as the product evolves. We may suspend or terminate access where these terms are breached or where required for security or legal reasons.",
        ],
      },
      {
        heading: "8. Limitation of liability",
        paragraphs: [
          "To the fullest extent permitted by Ghanaian law, InfoBoxx is not liable for decisions you make based solely on platform content, or for the acts or omissions of independent partners. Nothing in these terms excludes liability that cannot be excluded by law.",
        ],
      },
      {
        heading: "9. Governing law",
        paragraphs: [
          "These terms are governed by the laws of Ghana. Courts in Ghana have jurisdiction over disputes arising from these terms, without prejudice to any mandatory consumer protections that apply to you.",
        ],
      },
      {
        heading: "10. Contact",
        paragraphs: [
          "Questions about these Terms & Conditions can be sent to info@infoboxx.com or via the Contact page. For privacy-specific requests, see our Privacy Policy.",
        ],
      },
    ]}
  />
);

export default TermsAndConditionsPage;
